import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FooterGovSpComponent } from '../../components/footer-govsp/footer-govsp.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, FooterGovSpComponent],
  host: {
    class: 'notranslate',
    translate: 'no'
  }
})
export class AppComponent implements OnInit, OnDestroy {
  private traducaoObserver?: MutationObserver;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    this.setFavicon();
    this.bloquearTraducaoAutomatica();
  }

  ngOnDestroy(): void {
    this.traducaoObserver?.disconnect();
  }

  /** Mantém o documento em pt-BR e fora do tradutor do Chrome/Edge, inclusive se o usuário disparar a tradução. */
  private bloquearTraducaoAutomatica(): void {
    const html = this.document.documentElement;

    const aplicar = () => {
      if (html.lang !== 'pt-BR') {
        html.lang = 'pt-BR';
      }
      if (html.getAttribute('translate') !== 'no') {
        html.setAttribute('translate', 'no');
      }
      if (!html.classList.contains('notranslate')) {
        html.classList.add('notranslate');
      }

      const body = this.document.body;
      if (!body) {
        return;
      }
      if (body.getAttribute('translate') !== 'no') {
        body.setAttribute('translate', 'no');
      }
      if (!body.classList.contains('notranslate')) {
        body.classList.add('notranslate');
      }
    };

    aplicar();
    this.traducaoObserver = new MutationObserver(aplicar);
    this.traducaoObserver.observe(html, {
      attributes: true,
      attributeFilter: ['lang', 'translate', 'class']
    });
    if (this.document.body) {
      this.traducaoObserver.observe(this.document.body, {
        attributes: true,
        attributeFilter: ['translate', 'class']
      });
    }
  }

  private setFavicon(): void {
    const favicon = this.document.getElementById('favicon') as HTMLLinkElement;
    if (favicon) {
      if (environment.periodoEleitoral) {
        favicon.href = '//sedseecdn.azureedge.net/images/favicon_eleitoral/favicon.ico';
      } else {
        favicon.href = 'favicon.ico';
      }
    }
  }
}
